import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function OpeningHours({ openingHours }) {

    const { t } = useTranslation();

    if (!openingHours) {
        return null;
    }

    const dayMap = {
        monday: 'MA',
        tuesday: 'TI',
        wednesday: 'KE',
        thursday: 'TO',
        friday: 'PE',
        saturday: 'LA',
        sunday: 'SU'
    };

    const days = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];

    return (
        <Box className="opening-hours" sx={{ display: 'block', width: 'auto', maxWidth: '250px' }}>
            {days.map(day => {
                const info = openingHours[day];
                if (!info || !info.open || !info.close) return null;
                return (
                    <Box key={day} sx={{ display: 'flex',justifyContent: 'space-between' }}>
                        <Box sx={{ display: 'flex', minWidth: 50, textAlign: 'left', color: '#757575', fontSize: '0.9rem' }}>
                            {t(`workshop.${day}`)}
                        </Box>
                        <Box sx={{ display: 'flex', color: '#757575', fontSize: '0.9rem',textAlign:"right" }}>
                            {info.open} - {info.close}
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
}
